import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import {
  AddDocumentCertificateDetailsBoxStyled,
  AddDocumentDetailsBoxStyled,
  AddYourDocumentsCardStatusStyled,
  AddYourDocumentsCertificateStatusBoxStyled,
  ElectedBenefitTextStyled,
} from './AddYourDocumentsCardStyled';
import {
  DocumentRequest,
  DocumentTypeDto,
} from 'enrollment/features/ToDoList/types';
import { getDocName } from '../utils';
import { ViewDocumentDetailsDrawer } from './ViewDocumentDetailsDrawer';
import { ThemeStatusToBgColorMappingObj } from 'enrollment/app/constants';

interface UploadedDocumentsType {
  cardDetails: DocumentRequest;
  cardName: string;
  docTypes: DocumentTypeDto[];
  submittedDocType?: number;
  backgroundColor?: string;
  borderColor?: string;
  label?: string;
  imageId?: number;
}

export const UploadedDocuments = ({
  cardDetails,
  cardName,
  docTypes,
  submittedDocType,
  label,
  backgroundColor,
  borderColor,
  imageId,
}: UploadedDocumentsType) => {
  const { t } = useTranslation('pages.enrollmentAddYourDocuments');

  const electedBenefitValue = cardDetails.benefits_subject_to_termination
    ? cardDetails.benefits_subject_to_termination?.join(', ')
    : cardDetails.benefit_name;

  const terminateDate = moment(cardDetails.terminate_coverage_on).format(
    'MMMM DD, YYYY'
  );

  const bgColor =
    backgroundColor ||
    ThemeStatusToBgColorMappingObj(cardDetails.status_label)?.bgColor;
  const borderColors =
    borderColor ||
    ThemeStatusToBgColorMappingObj(cardDetails.status_label)?.borderColor;

  const docName = getDocName(
    docTypes,
    submittedDocType ||
      cardDetails.submitted_documents.find(
        (doc) => doc.id === cardDetails.subscriber_document_id
      )?.document_type_id
  );

  return (
    <div key={imageId || cardDetails.id}>
      <AddYourDocumentsCertificateStatusBoxStyled>
        <AddDocumentCertificateDetailsBoxStyled>
          <Typography variant="body1" gutterBottom>
            {docName}
          </Typography>
          {electedBenefitValue && (
            <ElectedBenefitTextStyled variant="body2" gutterBottom>
              {t('ElectedBenefit')}: {electedBenefitValue}
            </ElectedBenefitTextStyled>
          )}
          <AddYourDocumentsCardStatusStyled
            variant="overline"
            display="inline-block"
            backgroundColor={bgColor}
            borderColor={borderColors}
          >
            {label || cardDetails.status_label}
          </AddYourDocumentsCardStatusStyled>
        </AddDocumentCertificateDetailsBoxStyled>
        <AddDocumentDetailsBoxStyled>
          <Box>
            <ViewDocumentDetailsDrawer
              beneficiaryName={cardName}
              documentRequestId={cardDetails.id}
              docId={imageId}
              electedBenefits={electedBenefitValue}
              terminateDate={terminateDate}
            />
          </Box>
        </AddDocumentDetailsBoxStyled>
      </AddYourDocumentsCertificateStatusBoxStyled>
    </div>
  );
};
